import Component from "../../lib/Component.js";

const Notification = (options) => {
  let el;
  if (options.el) {
    el = options.el;
  } else if (options.message) {
    el = document.createElement("li");
    const iconHtml = options.icon ? `<i class="${options.icon} notification-icon"></i>` : "";
    el.innerHTML = `
      ${iconHtml}
      <div class="notification-content">
        ${options.title ? "<strong>" + options.title + "</strong>" : ""}
        <div>${options.message}</div>
      </div>
      <button class="close-notification"><i class="fas fa-times"></i></button>
    `;
  }

  const component = el
    ? new Component({
        componentName: "Notification",
        onMount() {
          const closeBtn = el.querySelector(".close-notification");
          if (closeBtn) {
            closeBtn.addEventListener("click", (e) => {
              e.stopPropagation();
              component.hide();
              console.log("Notification closed by user");
            });
          }
        },
        onUnmount() {
          el.remove();
        },
      })
    : Component.noop();

  component.el = el;

  component.show = (autohideTimeout) => {
    requestAnimationFrame(() => {
      const closeBtn = el.querySelector(".close-notification");

      el.classList.add("open");
      if (autohideTimeout !== false) {
        if (closeBtn) {
          closeBtn.style.display = "none";
        }
        window.setTimeout(() => {
          component.hide();
        }, autohideTimeout || 2000);
      }
    });
  };

  component.hide = () => {
    requestAnimationFrame(() => {
      el.classList.add("closed");
      window.setTimeout(() => {
        component.unmount();
      }, 500);
    });
  };

  return component;
};

const Notifications = (container) => {
  const component = container
    ? new Component({
        componentName: "Notifications",
        onMount() {},
        onUnmount() {},
      })
    : Component.noop();

  component.container = container;

  component.add = (title, message, icon) => {
    const notification = Notification({
      title: title,
      message: message,
      icon: icon,
    });
    notification.mount();

    if (container.childNodes.length > 0) {
      container.insertBefore(notification.el, container.childNodes[0]);
    } else {
      container.appendChild(notification.el);
    }
    return notification;
  };

  return component;
};

export default Notifications;
